export function setCaretPosition(
  element: HTMLInputElement,
  oldValue: string,
  newValue: string
): void {
  const { selectionEnd } = element;

  const prevPos = selectionEnd || 0;
  let newPos = prevPos;

  if (oldValue.length === prevPos) {
    newPos = newValue.length;
  }

  // to avoid caret jumping when editing value not at the end
  element.value = newValue;

  // set caret position
  element.setSelectionRange(newPos, newPos);
}

export function formatIban(
  iban: string | null | undefined,
  isIBANObfuscated: boolean
): string | null | undefined {
  if (!iban) {
    return iban;
  }

  const cleanedIban = iban
    .replace(/[^a-zA-Z0-9•]/g, '') //!\ in transfer request controller, IBAN are masked with dots
    .toUpperCase()
    .substring(0, 34)
    .replace(/(?<c1>.{4})/g, `$1 `)
    .trim();

  return isIBANObfuscated ? cleanedIban.replace(/x/gi, '•') : cleanedIban;
}

export function handleFormatIban(element: HTMLInputElement, isIBANObfuscated: boolean): void {
  const { value } = element;
  const newValue = formatIban(value, isIBANObfuscated);
  setCaretPosition(element, value, newValue || '');
}

export function maskInput(
  input: string | null | undefined,
  mask = 'X',
  padLeft = 4,
  padRight = 3
): string | null | undefined {
  if (!input || padLeft + padRight >= input.length) {
    return input;
  }

  const cleanedInput = input.replace(/[^a-zA-Z0-9•]/g, '');

  return `${cleanedInput.slice(0, padLeft)}${mask.repeat(
    cleanedInput.length - (padLeft + padRight)
  )}${cleanedInput.slice(cleanedInput.length - padRight)}`;
}
